import { POPUP, UPDATE_BOOKING } from '../constants'

const initState = {
	request: null,
	response: null,
	warning: null,
	error: null,
}

export default (state = initState, action) => {
	switch (action.type) {
		case UPDATE_BOOKING.LOAD:
			return {
				...state,
				request: action.request,
				response: null,
				warning: null,
				error: null,
			}
		case UPDATE_BOOKING.SUCCESS:
			return {
				...state,
				response: action.response,
				warning: action.response.warning,
			}
		case UPDATE_BOOKING.ERROR:
			return {
				...state,
				error: action.error,
			}
		case UPDATE_BOOKING.CLEAR:
			return {
				...state,
				response: null,
				warning: null,
				error: null,
			}
		case POPUP.CLOSE:
			return {
				...state,
				error: null,
			}
		default:
			return state
	}
}
